import moment from 'moment';

export default function tzTime(time: string | Date) {
  try {
    const tzTime = moment(time).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    return tzTime;
  } catch {
    return moment(time);
  }
}
